@if (isForbidLoading || isWithdrawForbid) {
  <deposit-withdraw-forbid [isLoading]="isForbidLoading"></deposit-withdraw-forbid>
} @else {
  <div class="scroll-cont">
    <div class="section">
      <div class="cont">
        <div class="row">
          <!-- 選擇幣別 -->
          <div class="item">
            <div class="label">
              <span>Select currency</span>
            </div>
            <cs-select
              [(value)]="currentCurrency"
              [options]="cryptoList"
              [disabled]="!isAllLoaded() || cryptoList.length == 0"
              (valueChange)="currencyChange()"
            ></cs-select>
          </div>
          <!-- 選擇網路 -->
          @if (walletService.useManualEnter) {
            <div class="item">
              <div class="label">
                <span>Select network</span>
              </div>
              <cs-select
                [(value)]="selectedNetwork"
                [options]="networkList"
                [disabled]="!isAllLoaded() || networkList.length == 0"
                (valueChange)="networkChange()"
              ></cs-select>
            </div>
          }
        </div>
        <div class="row">
          <div class="item">
            <div class="label">
              <span>Enter your address</span>
              <cs-button
                [label]="walletService.useManualEnter ? 'Use saved address' : 'Enter manually'"
                [disabled]="!isAllLoaded()"
                color="secondary"
                size="small"
                width="auto"
                (click)="switchAddressMode()"
              ></cs-button>
            </div>
            @if (walletService.useManualEnter) {
              <cs-input
                [marginBottom]="'0px'"
                [placeholder]="'Enter address manually'"
                [(value)]="manualAddress"
                [hasError]="!addressValid.isValid"
                [errorHint]="addressValid.text"
                (valueChange)="onAddressInput($event)"
                [disabled]="!selectedNetworkInfo"
              ></cs-input>
            } @else {
              <div
                style="flex-direction: column"
                [style.display]="addressList && addressList.length > 0 ? 'flex' : 'none'"
              >
                <div class="address-cont">
                  <cs-select
                    [(value)]="selectedAddress"
                    [options]="addressList"
                    [disabled]="!this.selectedAddressInfo?.network"
                    (valueChange)="addressChange()"
                  >
                    <ng-template #selectedTemplate let-selectedOption>
                      <div class="custom-select">
                        @if (selectedOption) {
                          {{ walletService.shortenAddress(selectedOption?.value) }}
                        } @else {
                          {{ 'Select an address' }}
                        }
                      </div>
                    </ng-template>
                    <ng-template #optionTemplate let-option>
                      <div class="custom-option">
                        <div class="desc">{{ option.data.labelA }}</div>
                        <div class="short-address">{{ option.data.labelB }}</div>
                      </div>
                    </ng-template>
                  </cs-select>
                  <cs-button
                    (buttonClick)="goSavedAddress()"
                    [iconLeft]="'fi-pencil-alt'"
                    [iconType]="'icon'"
                    [color]="'secondary'"
                    [size]="'large'"
                    [width]="'44px'"
                    [height]="'44px'"
                    [disabled]="!isAllLoaded()"
                  ></cs-button>
                </div>
                @if (this.selectedAddressInfo?.network) {
                  <div class="msg">Network: {{ this.selectedAddressInfo?.network }}</div>
                } @else {
                  <div class="msg">No saved address supported by this currency</div>
                }
              </div>
              <div [style.display]="addressList && addressList.length > 0 ? 'none' : 'flex'">
                <cs-button
                  style="margin: var(--xs) 0"
                  label="Save new address"
                  color="secondary"
                  size="large"
                  width="100%"
                  [disabled]="!isAllLoaded()"
                  (click)="goSavedAddress()"
                ></cs-button>
              </div>
            }
          </div>
        </div>
        <div class="row">
          <div class="item">
            <cs-input
              [label]="'Withdrawal amount'"
              [placeholder]="''"
              [inputMode]="'decimal'"
              [suffixText]="'Max'"
              [hasError]="!amountValid"
              [errorHint]="errText"
              [marginBottom]="'0px'"
              (suffixIconClick)="max()"
              [(value)]="amount"
              (valueChange)="onAmountInput()"
              [disabled]="!selectedNetworkInfo"
              input-float
            />
            <div class="msg big-msg">
              Available balance is <span>{{ coinLimitData?.availQuota || 0 | currencyValue: currentCurrency }}</span
              ><span>{{ currentCurrency }}</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="item">
            <cs-button
              label="Withdraw"
              color="accent"
              size="large"
              [disabled]="isWithdrawDisabled() && isAllLoaded()"
              [loading]="!isAllLoaded()"
              (buttonClick)="submit()"
            ></cs-button>
            @if (selectedNetworkInfo) {
              <div class="confirm-note-list">
                <div class="confirm-note-item">
                  <i class="icon" class="fi-exclamation-circle-filled"></i>
                  <p>
                    Your
                    <span class="mark"> {{ currentCurrency }} </span>
                    withdrawal will be sent via the
                    <span class="mark">
                      @for (item of networkList; track $index) {
                        @if (item.value === selectedNetwork) {
                          {{ item.label }}
                        }
                      }
                    </span>
                    network
                  </p>
                </div>
                @if (selectedNetworkInfo.withdrawFee.add(fee) > 0) {
                  <div class="confirm-note-item">
                    <i class="icon" class="fi-exclamation-circle-filled"></i>
                    <p>
                      A fee of
                      <span class="mark">
                        {{ selectedNetworkInfo.withdrawFee.add(fee) | currencyValue: currentCurrency }}
                        {{ currentCurrency }}
                      </span>
                      will be applied
                    </p>
                  </div>
                }
                <div class="confirm-note-item">
                  <i class="icon" class="fi-exclamation-circle-filled"></i>
                  <p>
                    The minimum withdrawal amount is
                    <span class="mark">
                      {{ selectedNetworkInfo.minAmount | number: '1.0-20' }} {{ currentCurrency }}
                    </span>
                  </p>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="note">
        <span>Already have a wallet?</span>
        <cs-button
          (buttonClick)="walletService.jump('withdraw', 'web3Wallet')"
          color="secondary"
          width="auto"
          size="small"
          label="Connect Wallet"
        ></cs-button>
      </div>
    </div>
  </div>
}
